import { FilterValue } from "../Filters/FilterValue";

export enum ProjectRequestStatusId {
  OPEN = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export enum ProjectRequestAction {
  FINANCE_APPROVE = "finance_approve",
  FINANCE_REJECT = "finance_reject",
}

export type ProjectRequestActionType =
  | ProjectRequestStatusId.APPROVED
  | ProjectRequestStatusId.REJECTED
  | ProjectRequestAction;

export const ProjectRequestStatus: FilterValue[] = [
  { id: "1", value: "OPEN" },
  { id: "2", value: "APPROVED" },
  { id: "3", value: "REJECTED" },
];

export const FinanceApprovalStatus: FilterValue[] = [
  { id: "1", value: "Finance Pending" },
  { id: "2", value: "Finance Approved" },
];
